export var AuthenticationOpenID;
(function (AuthenticationOpenID) {
    /**
     * Create a new OpenID Provider Registration
     *
     * @export
     * @class CreateOpenIDProvider
     * @implements {EvaService}
     */
    class CreateOpenIDProvider {
        name = 'AuthenticationOpenID:CreateOpenIDProvider';
        path = '/message/CreateOpenIDProvider';
        request;
        response;
    }
    AuthenticationOpenID.CreateOpenIDProvider = CreateOpenIDProvider;
    /**
     * Delete an existing OpenID Provider Registration
     *
     * @export
     * @class DeleteOpenIDProvider
     * @implements {EvaService}
     */
    class DeleteOpenIDProvider {
        name = 'AuthenticationOpenID:DeleteOpenIDProvider';
        path = '/message/DeleteOpenIDProvider';
        request;
        response;
    }
    AuthenticationOpenID.DeleteOpenIDProvider = DeleteOpenIDProvider;
    /**
     * Get all available openid provider configurations
     *
     * @export
     * @class GetAvailableOpenIDConfigurations
     * @implements {EvaService}
     */
    class GetAvailableOpenIDConfigurations {
        name = 'AuthenticationOpenID:GetAvailableOpenIDConfigurations';
        path = '/message/GetAvailableOpenIDConfigurations';
        request;
        response;
    }
    AuthenticationOpenID.GetAvailableOpenIDConfigurations = GetAvailableOpenIDConfigurations;
    /**
     * Get all info for a Azure OpenID Provider
     *
     * @export
     * @class GetOpenIDProviderByID
     * @implements {EvaService}
     */
    class GetOpenIDProviderByID {
        name = 'AuthenticationOpenID:GetOpenIDProviderByID';
        path = '/message/GetOpenIDProviderByID';
        request;
        response;
    }
    AuthenticationOpenID.GetOpenIDProviderByID = GetOpenIDProviderByID;
    /**
     * List OpenID Provider Registrations
     *
     * @export
     * @class ListOpenIDProviders
     * @implements {EvaService}
     */
    class ListOpenIDProviders {
        name = 'AuthenticationOpenID:ListOpenIDProviders';
        path = '/message/ListOpenIDProviders';
        request;
        response;
    }
    AuthenticationOpenID.ListOpenIDProviders = ListOpenIDProviders;
    /**
     * Set the provider that will be the default available when logging in, non-primary providers have to be requested.
     *
     * @export
     * @class SetPrimaryOpenIDProvider
     * @implements {EvaService}
     */
    class SetPrimaryOpenIDProvider {
        name = 'AuthenticationOpenID:SetPrimaryOpenIDProvider';
        path = '/message/SetPrimaryOpenIDProvider';
        request;
        response;
    }
    AuthenticationOpenID.SetPrimaryOpenIDProvider = SetPrimaryOpenIDProvider;
    /**
     * Update an existing OpenID Provider Registration
     *
     * @export
     * @class UpdateOpenIDProvider
     * @implements {EvaService}
     */
    class UpdateOpenIDProvider {
        name = 'AuthenticationOpenID:UpdateOpenIDProvider';
        path = '/message/UpdateOpenIDProvider';
        request;
        response;
    }
    AuthenticationOpenID.UpdateOpenIDProvider = UpdateOpenIDProvider;
})(AuthenticationOpenID || (AuthenticationOpenID = {}));
//# sourceMappingURL=EVA.Authentication.OpenID.Services.js.map